var render = function (_h,_vm) {var _c=_vm._c;return _c('b-dropdown-header',_vm._g(_vm._b({},'b-dropdown-header',_vm.props,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }